import React from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import _ from 'lodash';
import * as pathUtils from '../../utils/path';
import * as config from '../../../config/site';

// appsolut base components
import StyledBox from '../../components/controls/StyledBox';
import StyledButton from '../../components/controls/StyledButton';

function CatalogSwitch({ catalogType, catalogSettings }) {
  const CODE_PRIMARY = config.catalog.catalog.primary;
  const CODE_SECONDARY = config.catalog.catalog.secondary;
  const { hasPrimary, primaryTitle } = catalogSettings;
  const { hasSecondary, secondaryTitle } = catalogSettings;
  const hasMultiCatalog = hasPrimary && hasSecondary;

  const isPrimary = catalogType === CODE_PRIMARY;
  const altCatalogType = isPrimary ? CODE_SECONDARY : CODE_PRIMARY;
  const altCatalogTitle = isPrimary ? secondaryTitle : primaryTitle;
  const pagePath = pathUtils.createPagePathOfMultiCatalog(altCatalogType, '', '', catalogSettings);

  // event handler
  const handleButtonClick = () => {
    navigate(pagePath);
  };

  // parameters
  const showButton = hasMultiCatalog;
  const btnLabel = `Zum ${altCatalogTitle} Katalog`;
  const btnSize = 'medium';
  const btnVariant = 'gradient';
  const btnColor = 'white';

  // console.log(`=== SWITCH ===`);
  // console.log(`catalogType: ${catalogType}`);
  // console.log(`hasMultiCatalog: ${hasMultiCatalog}`);
  // console.log(`altCatalogType: ${altCatalogType}`);
  // console.log(catalogSettings);

  return (
    <>
      {showButton && (
        <StyledBox mt={2} mr={2}>
          <StyledButton
            onClick={handleButtonClick}
            variant={btnVariant}
            size={btnSize}
            color={btnColor}
          >
            {btnLabel}
          </StyledButton>
        </StyledBox>
      )}
    </>
  );
}

CatalogSwitch.propTypes = {
  catalogType: PropTypes.string.isRequired,
  catalogSettings: PropTypes.instanceOf(Object),
};

export default CatalogSwitch;
